import React from "react";
import { CheckCircle2, AlertTriangle, XCircle, Circle } from "lucide-react";

const MAP = {
  ok: { cls: "badge-ok", Icon: CheckCircle2, label: "In range" },
  warn: { cls: "badge-warn", Icon: AlertTriangle, label: "Warning" },
  bad: { cls: "badge-bad", Icon: XCircle, label: "Out of range" },
  neutral: { cls: "bg-secondary text-muted-foreground border border-border", Icon: Circle, label: "-" },
};

export const StatusBadge = ({ status = "neutral", label, testid }) => {
  const m = MAP[status] || MAP.neutral;
  const Icon = m.Icon;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${m.cls}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {label || m.label}
    </span>
  );
};
